<template>
    <div class="card-container Financial">

        <el-row :gutter="0" style="display: block;">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
                <div class="flex-col vertical-start">
                    <p class="title blue-text">通道余额查询：</p>
                    <div class="flex-row vertical-center flow-wrap">
                        <common-el-form :model="selectModel" :inline="true" :rules="selectRules" :showButton="false"
                                        :submitService="selectService"
                                        :submitData="selectData" @success="onSelectSuccess" @fail="onFail"
                                        ref="selectModel"
                                        submitBtnText="查询">
                            <el-form-item label="通道名称" prop="chnId">
                                <el-select v-model="selectModel.chnId" filterable>
                                    <el-option
                                        v-for="item in topchnNameList"
                                        :key="item.id"
                                        :label="item.chnName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </common-el-form>
                        <p class="account title">账户余额：{{toDoubleThousands(amount * 100 / 10000)}}</p>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
                <div class="flex-col vertical-start">
                    <p class="title blue-text">通道余额提现：</p>
                    <div class="flex-row vertical-center flow-wrap">
                        <common-el-form :model="cashModel" :inline="true" :rules="cashRules" :showButton="false"
                                        :submitService="cashService" :submitData="cashData" @success="oncashSuccess" @fail="onFail"
                                        ref="cashModel" submitBtnText="提现">
                            <el-form-item label="通道名称" prop="chnId">
                                <el-select v-model="cashModel.chnId" filterable>
                                    <el-option
                                        v-for="item in topchnNameList"
                                        :key="item.id"
                                        :label="item.chnName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="money">
                                <el-input-number v-model="cashModel.money" :controls="false" controls-position="right"
                                                 :precision="2" :step="0.1" :min="0"></el-input-number>
                            </el-form-item>
                        </common-el-form>

                    </div>
                </div>
            </el-col>
        </el-row>

        <el-button  type="primary" class="button-size title" @click="getList">查询</el-button>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="chnName" label="通道名称" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="money" label="提现金额" min-width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p class="ellipsis">{{toDoubleThousands(scope.row.money *100 / 10000) || '——'}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="cardNo" label="提现到账卡" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cardName" label="持卡人姓名" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="提现状态" :formatter="formatText" min-width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="提现时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="retMsg" label="备注" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="modifier" label="操作人" min-width="100"></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonElForm from "components/common/CommonElForm";
    import CommonTable from 'components/common/CommonTable'
    import OrganService from 'service/OrganService'
    import FinanceService from 'service/FinanceService'
    import ChannelService from 'service/ChannelService'
    import CommonTopForm from 'components/common/CommonTopForm'
    import SelectOrgans from 'components/business/SelectOrgans'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'
    import TimeRange from 'service/constant/TimeRange'

    export default {
        name: "privatecashout",
        data() {
            return {
                tableData: [],
                submitService: FinanceService.shareWithdrawalList,
                selectService: FinanceService.shareWithdrawalBalanceQuery,
                cashService: FinanceService.shareWithdrawalAdd,
                page: {},
                statusArr: [
                    {
                        id: 0,
                        value: '失败'
                    }, {
                        id: 1,
                        value: '成功'
                    }, {
                        id: 2,
                        value: '处理中'
                    }
                ],
                amount: '',
                selectModel: {
                    chnId: '',
                },
                cashModel: {
                    chnId: '',
                    money: 0,
                },
                selectRules: {
                    chnId: [{
                        required: true,
                        message:'请选择通道名称',
                        trigger: 'change'
                    }],
                },
                cashRules: {
                    chnId: [{
                        required: true,
                        message:'请选择通道名称',
                        trigger: 'change'
                    }],
                },
                isPage: false,
                topchnNameList: []
            }
        },
        mixins: [loadMixin, dialogMixin],
        components: {
            SelectOrgans,
            CommonElForm,
            CommonTable,
            CommonTopForm,
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getchnNameList();
            this.getList();
        },
        computed: {
            submitData() {
                let params = {
                    userId: this.userId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return params
            },
            selectData() {
                let params = {
                    userId: this.userId,
                    chnCode: this.selectModel.chnId
                };
                return params
            },
            cashData() {
                let params = {
                    userId: this.userId,
                    chnCode: this.cashModel.chnId,
                    money: this.cashModel.money
                };
                return params
            },
            ...mapGetters(['serverType', 'tatId', 'userId']),
        },
        methods: {
            getchnNameList() {
                this.doLoad(ChannelService.names, '', res => {
                    this.doCheck(res, res => {
                        this.topchnNameList = res.contents;
                    });
                }, '信息获取失败')
            },
            formatText(row, column, cellValue) {
                let value = '--';
                this.statusArr.forEach(item => {
                    if (item.id == cellValue) {
                        value = item.value
                    }
                });
                return value
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(res){
                const result = res.contents;
                this.tableData = result.rows;

                this.page.currentPage = result.current;
                this.page.pageSize = result.size;
                this.page.total = result.total;
            },
            onSelectSuccess(res) {
                this.amount = res.contents
            },
            oncashSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            onFail() {
                this.getList();
            },
        }
    }
</script>

<style scoped>
    .title{
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/PrivateCashOut.vue